export const kpiTooltipConfig = {
  revenue: {
    title: 'Revenue',
    timePeriod: 'ltm',
    description: [
      'This shows the median earnings of Airbnb listings in the market over the past 12 months. It includes both accommodation revenue and cleaning fees.',
    ],
    calculation: [
      'Total revenue ({revenue}) = Accommodation revenue ({accommodation_revenue})  + Cleaning fee revenue ({cleaning_fee_revenue})',
      'Accommodation revenue ({accommodation_revenue}) = Nightly rate ({nightly_rate}) × Occupancy rate ({occupancy_rate}) × 365 nights',
      'Cleaning fee revenue ({cleaning_fee_revenue}) = Number of bookings ({no_of_bookings}) × Cleaning fee ({cleaning_fee})',
    ],
    ctaUrl: 'https://airbtics.com/glossary#revenue',
  },
  occupancy: {
    title: 'Occupancy Rate',
    timePeriod: 'ltm',
    description: [
      'This shows the median of (booked nights / available nights) for Airbnb listings in the market over the past 12 months.',
    ],
    ctaUrl: 'https://airbtics.com/glossary#occupancy-rate',
  },
  daily: {
    title: 'Nightly Rate',
    timePeriod: 'ltm',
    description: [
      'This shows the median booked nightly rate of Airbnb listings in the market. It does not include cleaning fees, platform fees, or extra guest fees.',
    ],
    ctaUrl: 'https://airbtics.com/glossary#nightly-rate',
  },
  listing: {
    title: 'Active Listings',
    timePeriod: 'ltm',
    description: [
      'This shows the number of listings that were active for 90+ days in the last 12 months.',
      'It may differ from the monthly supply graph, which shows listings that were active in a specific month.',
    ],
    ctaUrl: 'https://airbtics.com/glossary#active-listings',
  },
  seasonality: {
    title: 'Seasonality',
    timePeriod: 'ltm',
    description: [
      'This shows how revenue changes month to month compared to the yearly average. Calculated as the revenue difference between the highest and lowest months.',
    ],
    calcRef: [
      'High seasonality: Revenue changes significantly throughout the year (> 75%).',
      'Mid seasonality: Revenue shows moderate variation during the year (51% to 75%).',
      'Low seasonality: Revenue remains relatively consistent throughout the year (≤ 50%).',
    ],
    ctaUrl: 'https://airbtics.com/glossary#seasonality',
  },
  trend: {
    title: 'Trend',
    timePeriod: 'ltm',
    description: ['This shows year-over-year changes in revenue.'],
    ctaUrl: 'https://airbtics.com/glossary#trend',
  },
  revenueIndividualListing: {
    title: 'Revenue',
    timePeriod: 'ltm',
    description: [
      'This shows the total earnings of this Airbnb listing over the past 12 months. It includes both accommodation revenue and cleaning fees.',
    ],
  },
  occupancyIndividualListing: {
    title: 'Occupancy Rate',
    timePeriod: 'ltm',
    description: [
      'This shows the average of (booked nights / available nights) for this Airbnb listing over the past 12 months. Currently, months with 0 bookings are excluded from this average. We plan to include them starting next month for a more accurate view.',
    ],
  },
  dailyIndividualListing: {
    title: 'Nightly Rate',
    timePeriod: 'ltm',
    description: [
      'This shows the average booked nightly rate of this Airbnb listing. It does not include cleaning fees, platform fees, or extra guest fees.',
    ],
  },
  revenuePotentialIndividualListing: {
    title: 'Revenue Potential',
    timePeriod: 'ltm',
    description: [
      'Revenue Potential is the revenue that the listing could have earned if it was active every day for the past 12 months.',
    ],
    calculation: ['Revenue Potential: = (Revenue / Days available) * 365'],
  },
  daysAvailableIndividualListing: {
    title: 'Days Available',
    timePeriod: 'ltm',
    description: [
      'Total number of days this Airbnb listing was available for booking over the past 12 months',
    ],
  },
};
